import React from "react";
import { useParams } from "react-router-dom";
import CloudinaryAdvancedImage from "@common/utils/CloudinaryAdvancedImage";
import { processJSXContent } from "@common/utils/blogHyperlinks";

function BlogInfography({ imageUrl, imageTitle, infoTitle, infoDescription }) {
  const { slug } = useParams();

  const isFirstBlog =
    slug === "how-sustainable-fabrics-are-shaping-the-future-of-home-decor";

  const link = imageTitle.toLowerCase().includes("LOCOMOTION".toLowerCase()) ? "/collection-detail/locomotion" : "/collection-detail/eco-dimout-textures";

  return (
    <div className="bs-blog-infography">
      <div style={{ display: "block", width: "100%", textAlign: "center" }}>
        {imageUrl && imageUrl.startsWith('/') ? (
          <img src={imageUrl} alt={imageTitle} className='bs-blog-infography__image' style={{ width: '100%', display: 'block', objectFit: 'cover' }} />
        ) : (
          <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-blog-infography__image' type="full-width-feature-banner" />
        )}
        <a href={link.toLowerCase()} className='bs-blog-infography__title-wrap' style={{ display: "block", width: "100%" }}>
          <label className='bs-blog-infography__media-title'>{imageTitle}</label>
        </a>
      </div>
      <div className="bs-blog-infography__info-wrap">
        <h2
          className="bs-blog-infography__info-title"
          dangerouslySetInnerHTML={processJSXContent(infoTitle)}
        ></h2>
        <p
          className="bs-blog-infography__info-desc"
          dangerouslySetInnerHTML={processJSXContent(infoDescription)}
        ></p>
      </div>
    </div>
  );
}

export default BlogInfography;
